import { VrioContentType } from '@dtvgo/constants';
import { normalize } from '@dtvgo/typed-normalizr';
import { SectionId } from '../../utils/normalizr/constants.js';
import { ContentEntity, ShowEntity, CarouselEntity } from '../../utils/normalizr/entities.js';
import '../../utils/normalizr/interfaces.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import 'query-string';
import '../../utils/normalizr/utils.js';

function thinkAnalytics(backendAxiosInstance) {
  async function addToMyList(addToMyListParams) {
    return backendAxiosInstance.post("/experiences/v3/recommendation/mylist", addToMyListParams);
  }
  async function getContinueWatchingShow(showId) {
    const response = await backendAxiosInstance.get(`/experiences/v3/recommendation/continuewatching/show/${showId}`, {
      includeTimeZone: true
    });
    response.normalizedData = normalize(response.data.contents, [ContentEntity]);
    return response;
  }
  async function getContinueWatchingMovie({ vmsId, vrioAssetId }) {
    const response = await backendAxiosInstance.get(`/experiences/v3/recommendation/continuewatching/movie/${vmsId}`, {
      includeTimeZone: true
    });
    response.normalizedData = normalize({
      vrioAssetId,
      vod: {
        progress: response.data.progress
      }
    }, ContentEntity);
    return response;
  }
  async function getMoreLikeThis({
    contentId,
    vmsId,
    contentSourceType,
    showId
  }) {
    const response = await backendAxiosInstance.get(
      "/experiences/v3/recommendation/morelikethis",
      {
        params: { id: vmsId, contentSourceId: contentSourceType },
        includeTimeZone: true
      }
    );
    response.normalizedData = normalize({
      vrioAssetId: showId || contentId,
      moreLikeThis: response.data.contents
    }, showId ? ShowEntity : ContentEntity);
    return response;
  }
  async function getMostwatchedChannels() {
    const response = await backendAxiosInstance.get("/experiences/v3/recommendation/mostwatchedchannels", {
      includeTimeZone: true
    });
    response.normalizedData = normalize({
      sourceCarouselId: SectionId.MOST_WATCHED,
      contents: response.data.contents?.sort((contentA, contentB) => contentB.rank - contentA.rank)?.map(({ vrioAssetId }) => ({
        channelId: vrioAssetId,
        type: VrioContentType.CHANNEL
      }))
    }, CarouselEntity);
    return response;
  }
  async function getMyList() {
    return backendAxiosInstance.get("/experiences/v3/recommendation/mylist", {
      includeDeviceType: true
    });
  }
  async function getRecentlyWatchedChannels() {
    return backendAxiosInstance.get("/experiences/v3/recommendation/recentlywatchedchannels", {
      includeDeviceType: true,
      includeTimeZone: true
    });
  }
  async function removeFromMyList({ id, type }) {
    return backendAxiosInstance.delete(`/experiences/v3/recommendation/mylist/${id}`, { params: { type } });
  }
  return {
    addToMyList,
    getContinueWatchingShow,
    getContinueWatchingMovie,
    getMoreLikeThis,
    getMostwatchedChannels,
    getMyList,
    getRecentlyWatchedChannels,
    removeFromMyList
  };
}

export { thinkAnalytics as default };
//# sourceMappingURL=thinkAnalytics.js.map
